<template>
  <div class="media">
    <img
      v-if="company.image && company.image.url"
      :src="company.image.url"
      style="width: 100px"
      class="mr-3"
    />
    <div class="media-body">
      <p class="text-lg mt-0">
        {{
          company.title.length < 30
            ? company.title
            : company.title.substring(0, 30) + ".."
        }}
      </p>
      <a :href="company.link">{{ $t("Show more") }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyInfo",

  props: {
    company: { type: Object },
  },
};
</script>
